import React from 'react';
import BotaoDuplo from './BotaoDuplo';
import ModalView from './ModalView';
import '../Estilos/EstiloBotao.css';

/**
 * This component renders a confirmation modal with dynamic content based on the 'confirmar' prop.
 * @param {string} nome - Title of the button.
 * @param {number} perfil - Status of the profile.
 * @param {boolean} confirmar - Determines if the confirmation view or a choice view is shown.
 * @param {string} aviso - Message to display in the modal.
 * @param {Function} clicado - Handler for the primary button click.
 * @param {Function} clicadoVolta - Handler for the secondary button click, if used.
 */
export default function ModalConfirmacao({ confirmar, erro, aviso, clicado, clicadoVolta }) {
  return (
    <ModalView height={372} width={610}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <img
          src={
            confirmar
              ? require('../Icones/check.svg').default
              : require('../Icones/alerta.svg').default
          }
          alt={confirmar ? 'Check icon' : 'Alert icon'}
        />

        <h4 style={{ color: '#2f2f2f', fontSize: 16, fontFamily: 'Montserrat', fontWeight: 500 }}>
          {aviso}
        </h4>

        {confirmar || erro ? (
          <button id="BotaoConfirma" onClick={clicado}>
            Ok
          </button>
        ) : (
          <BotaoDuplo
            externo
            clicado={clicado}
            clicadoVolta={clicadoVolta}
            nome="Sim"
            nomeVolta="Não"
          />
        )}
      </div>
    </ModalView>
  );
}
